import React from 'react';
import { Link } from 'react-router-dom';

const BOOKING_URL = 'https://cryobybreum.planway.com/';

export default function BodyRollSeoSection() {
  return (
    <div className="body-roll-seo-section">
      {/* 1. INTRODUKTION & HOVEDBUDSKAB */}
      <section className="py-20 lg:py-28 bg-cream border-b border-taupe-border/60">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl space-y-6 reveal-on-scroll">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-sand text-espresso text-[11px] font-semibold uppercase tracking-widest border border-taupe-border">
              <i className="fa-solid fa-fire-flame-simple text-accent-brown text-xs" aria-hidden="true" />
              <span>Rytmisk massage & Infrarød varme · Odense SV</span>
            </div>

            <h2 className="font-sans text-3xl sm:text-4xl lg:text-5xl font-semibold text-espresso uppercase tracking-wider leading-[1.2]">
              Body Roll behandling i Odense med infrarød varme
            </h2>

            <div className="pl-4 sm:pl-6 border-l-2 border-accent-brown/70 py-1">
              <p className="text-base sm:text-lg text-taupe font-normal leading-relaxed">
                Hos{' '}
                <Link to="/" className="text-espresso font-semibold hover:text-accent-brown underline underline-offset-4 decoration-accent-brown/50 hover:decoration-accent-brown transition-colors">
                  Cryo By Breum
                </Link>{' '}
                kan du vælge Body Roll i Odense, når du ønsker en behagelig kombination af rytmisk massage og infrarød varme. Behandlingen er til dig, der vil prioritere velvære, støtte kroppens naturlige flow og give spændte eller trætte områder en grundig massage.
              </p>
            </div>

            {/* Hurtige overblikspunkter */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-6">
              <div className="p-5 bg-sand-light/60 border border-taupe-border/80">
                <span className="block text-[10px] font-bold text-accent-brown uppercase tracking-widest">Rytmisk Massage</span>
                <span className="text-sm font-semibold text-espresso block mt-1">Roterende ruller</span>
                <span className="text-xs text-taupe mt-0.5 block">Rolige og gentagne bevægelser</span>
              </div>
              <div className="p-5 bg-sand-light/60 border border-taupe-border/80">
                <span className="block text-[10px] font-bold text-accent-brown uppercase tracking-widest">Infrarød Varme</span>
                <span className="text-sm font-semibold text-espresso block mt-1">Dyb velvære</span>
                <span className="text-xs text-taupe mt-0.5 block">Behagelig fornemmelse tæt på kroppen</span>
              </div>
              <div className="p-5 bg-sand-light/60 border border-taupe-border/80">
                <span className="block text-[10px] font-bold text-accent-brown uppercase tracking-widest">Klinik & Rammer</span>
                <span className="text-sm font-semibold text-espresso block mt-1">Odense & resten af Fyn</span>
                <span className="text-xs text-taupe mt-0.5 block">Dalumvej 82, 5250 Odense SV</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 2. HVAD ER BODY ROLL, OG HVAD MÆRKER DU UNDERVEJS? */}
      <section className="py-20 lg:py-24 bg-warm-beige border-b border-taupe-border/60">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-12 reveal-on-scroll">
            <div className="max-w-3xl space-y-3">
              <span className="text-[11px] font-bold uppercase tracking-widest text-accent-brown">Metode & Oplevelse</span>
              <h3 className="font-sans text-2xl sm:text-3xl lg:text-4xl font-semibold text-espresso uppercase tracking-wider">
                Hvad er Body Roll, og hvad mærker du undervejs?
              </h3>
              <p className="text-base sm:text-lg text-taupe leading-relaxed">
                En body roll behandling foregår ved hjælp af en maskine med roterende ruller, som masserer kroppen med rolige og gentagne bevægelser. Du styrer din placering ved maskinen, så forskellige områder kan få opmærksomhed. Intensiteten skal føles tydelig, men samtidig være tilpasset dig.
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
              {/* Kort 1: Hud & underliggende væv */}
              <div className="p-8 sm:p-10 bg-cream border border-taupe-border/80 space-y-5 flex flex-col justify-between shadow-xs">
                <div className="space-y-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-sand border border-taupe-border text-espresso">
                    <i className="fa-solid fa-rotate text-lg" aria-hidden="true" />
                  </div>
                  <h4 className="font-sans text-lg sm:text-xl font-semibold text-espresso uppercase tracking-wider">
                    Varm og stimulerende fornemmelse
                  </h4>
                  <p className="text-sm sm:text-base text-taupe leading-relaxed">
                    De rytmiske bevægelser påvirker hud og underliggende væv og kan give en varm og stimulerende fornemmelse. Nogle vælger Body Roll med fokus på restitution og trætte ben. Andre ønsker en afslappende kropsbehandling eller vil arbejde med hudens følelse og udseende.
                  </p>
                </div>
                <div className="pt-4 border-t border-taupe-border/50 text-xs text-taupe-light flex items-center gap-2">
                  <i className="fa-solid fa-check text-accent-brown" aria-hidden="true" />
                  <span>Målrettet restitution for trætte muskler og ben</span>
                </div>
              </div>

              {/* Kort 2: De 3 nøgleelementer */}
              <div className="p-8 sm:p-10 bg-cream border border-taupe-border/80 space-y-5 flex flex-col justify-between shadow-xs">
                <div className="space-y-5">
                  <div className="w-12 h-12 flex items-center justify-center bg-sand border border-taupe-border text-espresso">
                    <i className="fa-solid fa-spa text-lg" aria-hidden="true" />
                  </div>
                  <h4 className="font-sans text-lg sm:text-xl font-semibold text-espresso uppercase tracking-wider">
                    Behandlingens grundelementer
                  </h4>
                  <ul className="space-y-3 pt-1">
                    <li className="flex items-start gap-3 text-sm sm:text-base text-taupe">
                      <div className="w-5 h-5 rounded-full bg-sand flex items-center justify-center shrink-0 mt-0.5 border border-taupe-border/60">
                        <i className="fa-solid fa-check text-[10px] text-accent-brown" aria-hidden="true" />
                      </div>
                      <span className="font-medium text-espresso">Rytmisk massage af udvalgte områder på kroppen</span>
                    </li>
                    <li className="flex items-start gap-3 text-sm sm:text-base text-taupe">
                      <div className="w-5 h-5 rounded-full bg-sand flex items-center justify-center shrink-0 mt-0.5 border border-taupe-border/60">
                        <i className="fa-solid fa-check text-[10px] text-accent-brown" aria-hidden="true" />
                      </div>
                      <span className="font-medium text-espresso">Behagelig infrarød varme under behandlingen</span>
                    </li>
                    <li className="flex items-start gap-3 text-sm sm:text-base text-taupe">
                      <div className="w-5 h-5 rounded-full bg-sand flex items-center justify-center shrink-0 mt-0.5 border border-taupe-border/60">
                        <i className="fa-solid fa-check text-[10px] text-accent-brown" aria-hidden="true" />
                      </div>
                      <span className="font-medium text-espresso">Fokus på velvære, bevægelse og kropslig ro</span>
                    </li>
                  </ul>
                </div>
                <div className="pt-4 border-t border-taupe-border/50 text-xs text-taupe-light flex items-center gap-2">
                  <i className="fa-solid fa-shield-heart text-accent-brown" aria-hidden="true" />
                  <span>En afbalanceret kombination tilpasset dit tempo</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3. MASSAGE OG INFRARØD VARME SKABER EN SÆRLIG OPLEVELSE */}
      <section className="py-20 lg:py-28 bg-sand-light border-b border-taupe-border/80">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-12 reveal-on-scroll">
            <div className="max-w-3xl space-y-4">
              <span className="text-[11px] font-bold uppercase tracking-widest text-accent-brown">Synergi & Velvære</span>
              <h3 className="font-sans text-2xl sm:text-3xl lg:text-4xl font-semibold text-espresso uppercase tracking-wider">
                Massage og infrarød varme skaber en særlig oplevelse
              </h3>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-stretch">
              {/* Venstre side: Dybdegående forklaring */}
              <div className="lg:col-span-7 space-y-6">
                <div className="p-8 sm:p-10 bg-cream border border-taupe-border space-y-6">
                  <div className="space-y-4 text-sm sm:text-base text-taupe leading-relaxed">
                    <p>
                      Den infrarøde varme er en vigtig del af behandlingen. I stedet for kun at opvarme luften opleves varmen tæt ved kroppen, hvor den bidrager til en behagelig og afslappende fornemmelse. Kombinationen af varme og massage gør Body Roll velegnet som en rolig pause i en travl hverdag.
                    </p>
                    <p>
                      Varmen kan gøre det mere behageligt at arbejde med områder, der føles spændte eller trætte. Samtidig skaber rullernes bevægelser en mekanisk massage, som stimulerer vævet og blodcirkulationen lokalt. Oplevelsen og effekten er individuel og afhænger blandt andet af dit udgangspunkt.
                    </p>
                  </div>

                  <div className="pt-4 border-t border-taupe-border/60 grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div className="p-4 bg-sand/60 border border-taupe-border/60 flex items-start gap-3">
                      <i className="fa-solid fa-temperature-arrow-up text-accent-brown mt-1 shrink-0" aria-hidden="true" />
                      <div>
                        <h5 className="font-sans text-xs font-bold text-espresso uppercase tracking-wider">Infrarød varme</h5>
                        <p className="text-xs text-taupe mt-1">Opleves tæt ved kroppen for dyb afslapning</p>
                      </div>
                    </div>
                    <div className="p-4 bg-sand/60 border border-taupe-border/60 flex items-start gap-3">
                      <i className="fa-solid fa-arrows-spin text-accent-brown mt-1 shrink-0" aria-hidden="true" />
                      <div>
                        <h5 className="font-sans text-xs font-bold text-espresso uppercase tracking-wider">Mekanisk stimulering</h5>
                        <p className="text-xs text-taupe mt-1">Styrker lokalt væv og blodcirkulation</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Højre side: Oplevelseskort */}
              <div className="lg:col-span-5 flex flex-col justify-between p-8 sm:p-10 bg-sand border border-taupe-border/90 space-y-6">
                <div className="space-y-4">
                  <div className="inline-flex items-center gap-2 text-accent-brown text-xs font-bold uppercase tracking-wider">
                    <i className="fa-solid fa-clock" aria-hidden="true" />
                    <span>En rolig pause</span>
                  </div>
                  <h4 className="font-sans text-xl sm:text-2xl font-semibold text-espresso uppercase tracking-wider leading-snug">
                    Afslapning i en travl hverdag
                  </h4>
                  <p className="text-xs sm:text-sm text-taupe leading-relaxed">
                    Under en session vælger du selv positioner og vinkler, så du kan fokusere på de zoner, hvor kroppen har mest brug for aflastning og fornyet energi.
                  </p>
                </div>

                <div className="p-5 bg-sand-light/80 border border-taupe-border space-y-2">
                  <span className="text-[11px] font-bold text-espresso uppercase tracking-wider block">Fokuserede kropszoner</span>
                  <div className="flex flex-wrap gap-2 pt-1">
                    <span className="px-2.5 py-1 bg-cream text-espresso text-xs border border-taupe-border">Lår & ben</span>
                    <span className="px-2.5 py-1 bg-cream text-espresso text-xs border border-taupe-border">Balder & hofter</span>
                    <span className="px-2.5 py-1 bg-cream text-espresso text-xs border border-taupe-border">Ryg & talje</span>
                    <span className="px-2.5 py-1 bg-cream text-espresso text-xs border border-taupe-border">Arme</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. HVAD HAR BODY ROLL MED LYMFEDRÆNAGE MASSAGE AT GØRE? */}
      <section className="py-20 lg:py-28 bg-cream border-b border-taupe-border/60">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-12 reveal-on-scroll">
            <div className="max-w-3xl space-y-4">
              <span className="text-[11px] font-bold uppercase tracking-widest text-accent-brown">Afklaring & Forskelle</span>
              <h3 className="font-sans text-2xl sm:text-3xl lg:text-4xl font-semibold text-espresso uppercase tracking-wider">
                Hvad har Body Roll med lymfedrænage massage at gøre?
              </h3>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
              {/* Kolonne 1: Lymfesystemet og Body Roll */}
              <div className="p-8 sm:p-10 bg-warm-beige border border-taupe-border/80 space-y-6 flex flex-col justify-between">
                <div className="space-y-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-sand border border-taupe-border text-espresso">
                    <i className="fa-solid fa-water text-lg text-accent-brown" aria-hidden="true" />
                  </div>
                  <h4 className="font-sans text-lg sm:text-xl font-semibold text-espresso uppercase tracking-wider">
                    Støtte til det naturlige væskeflow
                  </h4>
                  <p className="text-sm sm:text-base text-taupe leading-relaxed">
                    Mange, der søger efter lymfedrænage massage i Odense, er nysgerrige på Body Roll. Behandlingens rytmiske bevægelser kan understøtte kroppens naturlige væskeflow. Lymfesystemet hjælper med at transportere væske rundt i kroppen og er en vigtig del af kroppens normale funktion.
                  </p>
                </div>
                <div className="p-4 bg-sand-light/60 border border-taupe-border/70 text-xs text-taupe flex items-center gap-2.5">
                  <i className="fa-solid fa-circle-check text-accent-brown" aria-hidden="true" />
                  <span>Understøtter kroppens naturlige kredsløb og transport</span>
                </div>
              </div>

              {/* Kolonne 2: Forskellen på manuel lymfedrænage og Body Roll */}
              <div className="p-8 sm:p-10 bg-sand-light border border-taupe-border/80 space-y-6 flex flex-col justify-between">
                <div className="space-y-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-sand border border-taupe-border text-espresso">
                    <i className="fa-solid fa-hand-holding-heart text-lg text-accent-brown" aria-hidden="true" />
                  </div>
                  <h4 className="font-sans text-lg sm:text-xl font-semibold text-espresso uppercase tracking-wider">
                    Maskinbaseret velvære vs. manuel behandling
                  </h4>
                  <p className="text-sm sm:text-base text-taupe leading-relaxed">
                    Body Roll er dog ikke det samme som manuel lymfedrænage, der udføres med særlige håndgreb af en uddannet behandler. Vores behandling er en maskinbaseret massage med infrarød varme og et velværeorienteret formål. Vi hjælper dig gerne med at afklare, hvad du kan forvente.
                  </p>
                </div>
                <div className="p-4 bg-cream border border-taupe-border/70 text-xs text-taupe flex items-center gap-2.5">
                  <i className="fa-solid fa-info-circle text-accent-brown" aria-hidden="true" />
                  <span>Velværeorienteret tilgang uden manuelle kliniske greb</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 5. ER EN BODY ROLL BEHANDLING NOGET FOR DIG? */}
      <section className="py-20 lg:py-28 bg-warm-beige border-b border-taupe-border/60">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start reveal-on-scroll">
            <div className="lg:col-span-7 space-y-6">
              <span className="text-[11px] font-bold uppercase tracking-widest text-accent-brown">Målgruppe & Hensyn</span>
              <h3 className="font-sans text-2xl sm:text-3xl lg:text-4xl font-semibold text-espresso uppercase tracking-wider">
                Er en Body Roll behandling noget for dig?
              </h3>
              
              <div className="space-y-4 text-sm sm:text-base text-taupe leading-relaxed">
                <p>
                  Body Roll kan være relevant, hvis du ønsker massage uden en traditionel briksbehandling. Den passer også til dig, der gerne vil kombinere bevægelse, varme og massage i samme session. Du behøver ikke have erfaring, da vi sørger for en tryg introduktion til maskinen og behandlingen.
                </p>
              </div>

              {/* 3 Kriterier */}
              <div className="space-y-3 pt-2">
                <div className="p-4 bg-cream border border-taupe-border flex items-start gap-4 shadow-xs">
                  <div className="w-8 h-8 rounded-full bg-sand flex items-center justify-center shrink-0 border border-taupe-border text-accent-brown text-sm">
                    <i className="fa-solid fa-heart" aria-hidden="true" />
                  </div>
                  <div>
                    <h5 className="font-sans text-sm font-semibold text-espresso">
                      Du ønsker en stimulerende massage med fokus på velvære
                    </h5>
                    <p className="text-xs text-taupe mt-0.5">En skånsom, men mærkbar kropsstimulering i dit eget tempo.</p>
                  </div>
                </div>

                <div className="p-4 bg-cream border border-taupe-border flex items-start gap-4 shadow-xs">
                  <div className="w-8 h-8 rounded-full bg-sand flex items-center justify-center shrink-0 border border-taupe-border text-accent-brown text-sm">
                    <i className="fa-solid fa-person-walking" aria-hidden="true" />
                  </div>
                  <div>
                    <h5 className="font-sans text-sm font-semibold text-espresso">
                      Du oplever trætte ben efter arbejde eller aktivitet
                    </h5>
                    <p className="text-xs text-taupe mt-0.5">Oplagt til at løsne op for tunge eller stive ben.</p>
                  </div>
                </div>

                <div className="p-4 bg-cream border border-taupe-border flex items-start gap-4 shadow-xs">
                  <div className="w-8 h-8 rounded-full bg-sand flex items-center justify-center shrink-0 border border-taupe-border text-accent-brown text-sm">
                    <i className="fa-solid fa-calendar-check" aria-hidden="true" />
                  </div>
                  <div>
                    <h5 className="font-sans text-sm font-semibold text-espresso">
                      Du vil gøre Body Roll til en del af din faste egenomsorg
                    </h5>
                    <p className="text-xs text-taupe mt-0.5">Regelmæssig brug som led i en sund kropsplejerutine.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Sundhed og forholdsregler boks */}
            <div className="lg:col-span-5 space-y-6">
              <div className="p-8 sm:p-10 bg-sand border border-taupe-border/90 space-y-6">
                <div className="inline-flex items-center gap-2 text-accent-brown text-xs font-bold uppercase tracking-wider">
                  <i className="fa-solid fa-shield-halved" aria-hidden="true" />
                  <span>Sundhed & Forholdsregler</span>
                </div>
                <h4 className="font-sans text-xl sm:text-2xl font-semibold text-espresso uppercase tracking-wider leading-snug">
                  Tryghed og personligt hensyn
                </h4>
                
                <div className="p-5 bg-cream border-l-2 border-accent-brown text-xs sm:text-sm text-taupe leading-relaxed space-y-3">
                  <p>
                    Har du sygdom, vedvarende smerter eller hævelse uden kendt årsag, anbefaler vi, at du taler med en sundhedsfaglig person inden booking. Body Roll er en velværebehandling og erstatter ikke undersøgelse eller behandling af en sygdom. Spørg os altid, hvis du er i tvivl.
                  </p>
                </div>

                <div className="space-y-3 pt-2">
                  <div className="flex items-start gap-3 text-xs text-taupe">
                    <i className="fa-solid fa-circle-info text-accent-brown mt-0.5 shrink-0" aria-hidden="true" />
                    <span>Vi tager os god tid til grundig instruktion inden din første tur.</span>
                  </div>
                  <div className="flex items-start gap-3 text-xs text-taupe">
                    <i className="fa-solid fa-user-doctor text-accent-brown mt-0.5 shrink-0" aria-hidden="true" />
                    <span>Lægelig vurdering anbefales altid ved usikkerhed om helbredstilstand.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 6. FIND ET FORLØB MED PLADS TIL DINE MÅL */}
      <section className="py-20 lg:py-28 bg-cream border-b border-taupe-border/60">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center reveal-on-scroll">
            <div className="lg:col-span-7 space-y-6">
              <span className="text-[11px] font-bold uppercase tracking-widest text-accent-brown">Fleksibilitet & Formål</span>
              <h3 className="font-sans text-2xl sm:text-3xl lg:text-4xl font-semibold text-espresso uppercase tracking-wider">
                Find et forløb med plads til dine mål
              </h3>
              
              <div className="space-y-4 text-sm sm:text-base text-taupe leading-relaxed">
                <p>
                  Nogle vælger en enkelt behandling for at lære Body Roll at kende, mens andre foretrækker et længere forløb. Det rigtige valg afhænger af dine ønsker, din hverdag og hvordan kroppen reagerer. Vi giver dig en ærlig introduktion, så du kan vælge uden at blive lovet bestemte resultater.
                </p>
                <p>
                  Body Roll har et andet formål end{' '}
                  <Link to="/behandlinger/ems-traening" className="text-espresso font-medium hover:text-accent-brown underline underline-offset-4 decoration-accent-brown/40 hover:decoration-accent-brown transition-colors">
                    EMS træning
                  </Link>{' '}
                  og{' '}
                  <Link to="/behandlinger/fedtfrysning" className="text-espresso font-medium hover:text-accent-brown underline underline-offset-4 decoration-accent-brown/40 hover:decoration-accent-brown transition-colors">
                    fedtfrysning
                  </Link>
                  . Er du usikker på forskellene, kan du udforske{' '}
                  <Link to="/priser" className="text-espresso font-medium hover:text-accent-brown underline underline-offset-4 decoration-accent-brown/40 hover:decoration-accent-brown transition-colors">
                    vores priser og forløb
                  </Link>{' '}
                  eller kontakte os for personlig vejledning i Odense.
                </p>
              </div>

              {/* Genveje til øvrige kropsbehandlinger */}
              <div className="pt-2 flex flex-wrap gap-4">
                <Link
                  to="/behandlinger/ems-traening"
                  className="inline-flex items-center gap-2 px-5 py-3 bg-sand-light border border-espresso text-espresso text-xs font-semibold uppercase tracking-wider hover:bg-white transition-colors"
                >
                  <span>Læs om EMS træning</span>
                  <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
                </Link>
                <Link
                  to="/behandlinger/fedtfrysning"
                  className="inline-flex items-center gap-2 px-5 py-3 bg-sand-light border border-espresso text-espresso text-xs font-semibold uppercase tracking-wider hover:bg-white transition-colors"
                >
                  <span>Læs om Fedtfrysning</span>
                  <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
                </Link>
              </div>
            </div>

            {/* Højre infokort: Enkelt vs forløb */}
            <div className="lg:col-span-5">
              <div className="p-8 sm:p-10 bg-sand border border-taupe-border space-y-6">
                <h4 className="font-sans text-lg font-semibold text-espresso uppercase tracking-wider">
                  Vælg det der passer dig
                </h4>
                <div className="space-y-4 text-xs sm:text-sm text-taupe leading-relaxed">
                  <div className="p-4 bg-cream border border-taupe-border/80 space-y-1">
                    <span className="font-semibold text-espresso block">Enkelt session</span>
                    <span>Oplagt til restitution efter sport eller en introduktion til fornemmelsen af rullerne og den infrarøde varme.</span>
                  </div>
                  <div className="p-4 bg-cream border border-taupe-border/80 space-y-1">
                    <span className="font-semibold text-espresso block">Klippekort eller forløb</span>
                    <span>For dig der vil have kontinuerlig kropspleje og gøre Body Roll til en fast del af hverdagens velvære.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 7. BOOK BODY ROLL HOS CRYO BY BREUM I ODENSE */}
      <section className="py-20 lg:py-28 bg-warm-beige border-b border-taupe-border/60">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center reveal-on-scroll">
            <div className="lg:col-span-7 space-y-6">
              <span className="text-[11px] font-bold uppercase tracking-widest text-accent-brown">Personlig Oplevelse</span>
              <h3 className="font-sans text-2xl sm:text-3xl lg:text-4xl font-semibold text-espresso uppercase tracking-wider">
                Book Body Roll hos Cryo By Breum i Odense
              </h3>
              
              <div className="space-y-4 text-sm sm:text-base text-taupe leading-relaxed">
                <p>
                  Hos os får du en personlig og uformel oplevelse med tid til at blive fortrolig med behandlingen. Vi tager imod kunder fra Odense og resten af Fyn. Før du går i gang, gennemgår vi Body Roll maskinen og hjælper dig med en indstilling, der føles tryg og behagelig.
                </p>
                <p>
                  Du kan booke din tid online, når det passer dig. Har du spørgsmål om Body Roll, infrarød varme eller forskellen på behandlingen og lymfedrænage massage, er du velkommen til at kontakte Cryo By Breum inden din booking.
                </p>
              </div>

              <div className="pt-2 flex flex-col sm:flex-row gap-4">
                <a
                  href={BOOKING_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-accent-brown text-white text-xs uppercase tracking-widest font-semibold hover:bg-accent-brown-hover transition-colors shadow-xs"
                >
                  <span>Book Body Roll online</span>
                  <i className="fa-solid fa-arrow-up-right-from-square text-xs" aria-hidden="true" />
                </a>
                <Link
                  to="/kontakt"
                  className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-cream text-espresso text-xs uppercase tracking-widest font-semibold border border-espresso hover:bg-white transition-colors"
                >
                  <span>Kontakt os</span>
                  <i className="fa-solid fa-envelope text-xs" aria-hidden="true" />
                </Link>
              </div>
            </div>

            {/* Handlingskort med klinikoplysninger */}
            <div className="lg:col-span-5">
              <div className="p-8 sm:p-10 bg-sand border border-taupe-border space-y-6">
                <h4 className="font-sans text-lg font-semibold text-espresso uppercase tracking-wider">
                  Klinikinformation
                </h4>
                <div className="space-y-3 text-xs sm:text-sm text-taupe">
                  <div className="flex items-center gap-3">
                    <i className="fa-solid fa-location-dot text-accent-brown shrink-0" aria-hidden="true" />
                    <span>Dalumvej 82, 5250 Odense SV</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="fa-solid fa-phone text-accent-brown shrink-0" aria-hidden="true" />
                    <a href="tel:+4528186175" className="hover:text-espresso underline">28 18 61 75</a>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="fa-solid fa-envelope text-accent-brown shrink-0" aria-hidden="true" />
                    <a href="mailto:kontakt@cryobybreum.dk" className="hover:text-espresso underline">kontakt@cryobybreum.dk</a>
                  </div>
                </div>

                <div className="pt-4 border-t border-taupe-border/60">
                  <a
                    href="#priser"
                    className="inline-flex items-center justify-center gap-2 w-full px-6 py-3 bg-cream text-espresso text-xs uppercase tracking-widest font-semibold border border-taupe-border hover:border-espresso transition-colors text-center"
                  >
                    <span>Se priser på Body Roll</span>
                    <i className="fa-solid fa-arrow-down text-xs" aria-hidden="true" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 8. AFSLUTTENDE BOOKING BAR */}
      <section className="py-16 bg-sand-light border-b border-taupe-border/60">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-5 reveal-on-scroll">
          <h3 className="font-sans text-xl sm:text-2xl font-semibold tracking-wider uppercase text-espresso">
            Klar til en behagelig pause med Body Roll?
          </h3>
          <p className="text-taupe text-sm sm:text-base max-w-xl mx-auto">
            Book din tid direkte på Planway eller udforsk vores priser nedenfor.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-2">
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-accent-brown text-white text-xs font-semibold uppercase tracking-widest hover:bg-accent-brown-hover transition-colors shadow-xs"
            >
              <span>Book tid online</span>
              <i className="fa-solid fa-arrow-up-right-from-square text-xs" aria-hidden="true" />
            </a>
            <a
              href="#priser"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-transparent text-espresso text-xs font-semibold uppercase tracking-widest border border-espresso hover:bg-cream transition-colors"
            >
              <span>Gå til prisoversigt</span>
              <i className="fa-solid fa-arrow-down text-xs" aria-hidden="true" />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
